/**
 * OCRサービス（フロントエンド用）
 */

import { httpsCallable } from "firebase/functions";
import { getFunctionsInstance } from "../lib/firebase";

export interface AnalyzeSampleResult {
  success: boolean;
  result: {
    structuredData: Record<string, unknown>;
    text: string;
    promptUsed?: string;
  };
}

export interface AnalyzeSampleInput {
  fileBase64: string;
  mimeType: string;
  fileName: string;
  additionalPrompt?: string;
}

/**
 * サンプルファイルを解析する
 */
export async function analyzeSampleFile(input: AnalyzeSampleInput): Promise<AnalyzeSampleResult> {
  const functions = getFunctionsInstance();
  const analyzeSampleFileFn = httpsCallable<AnalyzeSampleInput, AnalyzeSampleResult>(functions, "analyzeSampleFile");
  const result = await analyzeSampleFileFn(input);
  return result.data;
}
